import React from 'react';
import {Link} from 'react-router';

class RowItemBaoCaoTongHop extends React.Component {

  render() {
    return (
      <tr>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='list-items-table'>
          <Link className="txt-underline txt-regular" to={`/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-don-vi/${this.props.item.baoCaoTongHopId}`}>
            {this.props.item.tenBaoCao}
          </Link>
        </td>
        <td className='txt-left'>{this.props.item.kyBaoCaoInfo}</td>
        <td className='txt-left'>{this.props.item.namBaoCao}</td>
        <td className='txt-left'>{this.props.item.soDonViDaBaoCao} đơn vị</td>
      </tr>
    );
  }
}

export default RowItemBaoCaoTongHop;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemBaoCaoTongHop.jsx